import {
  memo, useEffect, useMemo, useState,
} from 'react';
import { debounce } from 'lodash';
import Typography from '../Typography';

import { useSecurityScore } from '../../hooks/useSecurityScore';
import { getSecurityScore } from '../../services';

export interface ISecurityScoreTextProps {
  password: string;
  getTranslation: (translationKey: string) => string;
}

const SCORE_CALCULATION_DEBOUNCE = 200;

const SecurityScoreText = (props: ISecurityScoreTextProps) => {
  const { password, getTranslation } = props;

  const [passwordSecurityScore, setPasswordSecurityScore] = useState<number>(
    () => getSecurityScore(password),
  );

  const debouncedCalculateSecurityScore = useMemo(
    () => debounce((passwordToCalculate: string) => {
      const score = getSecurityScore(passwordToCalculate);
      setPasswordSecurityScore(score);
    }, SCORE_CALCULATION_DEBOUNCE),
    [],
  );

  useEffect(() => {
    debouncedCalculateSecurityScore(password);
  }, [password, debouncedCalculateSecurityScore]);

  const { color, translationKey } = useSecurityScore({
    score: passwordSecurityScore,
  });
  return (
    <Typography variant="body1" color={color}>{getTranslation(translationKey)}</Typography>
  );
};

export default memo(SecurityScoreText);
